export default __webpack_public_path__ + "static/media/blog1.a5b99e8f.jpeg";